import { FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RouteGuard } from '@versita/frontend/auth-web';
import { Home } from './pages/Home';
import { ConstrainedLayout } from '@versita/frontend/campus-ui-web';
import { useUserWidget } from './hooks/useUserWidget';
import { CourseSelect } from './pages/CourseSelect';
import { CourseTimetable } from './pages/CourseTimetable';
import { StudentTimetable } from './pages/StudentTimetable';
import { Role } from '@versita/shared/models';
import { Login } from './pages/Login';
import * as Sentry from '@sentry/react';
import { TimeTableAdmin } from './pages/TimeTableAdmin';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<RouteGuard content={<Home />} loginPage={<Login />} />}
        />
        <Route
          path="/courses"
          element={
            <Page
              Content={CourseSelect}
              title="Course Search"
              subtitle="Course Timetables"
            />
          }
        />
        <Route
          path="/course/:courseId/:courseYear"
          element={<CourseTimetable />}
        />
        <Route
          path="/admin/student-timetable/:networkId"
          element={
            <RouteGuard
              roles={[Role.TIMETABLE_ADMIN, Role.TIMETABLE_MANAGER]}
              content={<StudentTimetable />}
              loginPage={<Login />}
            />
          }
        />
        <Route
          path="/admin/timetable/course"
          element={
            <RouteGuard
              content={
                <TimeTableAdmin
                  pageTitle="Course Timetables"
                  flavour="COURSE"
                />
              }
              roles={[Role.TIMETABLE_ADMIN]}
              loginPage={<Login />}
            />
          }
        />
        <Route
          path="/admin/timetable/student"
          element={
            <RouteGuard
              content={
                <TimeTableAdmin
                  pageTitle="Student Timetables"
                  flavour="STUDENT"
                />
              }
              roles={[Role.TIMETABLE_ADMIN]}
              loginPage={<Login />}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
/**
 * Injects layout with userWidgetProps and
 * proxies some other props
 */
export const Page = ({
  Content,
  title,
  subtitle,
}: {
  Content: FC;
  title: string;
  subtitle?: string;
}) => {
  const userWidgetProps = useUserWidget();
  return (
    <ConstrainedLayout
      userWidget={userWidgetProps}
      heading={{ title, subtitle }}
    >
      <Content />
    </ConstrainedLayout>
  );
};
export default Sentry.withProfiler(App);
